import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { supabase } from '../lib/supabase.js';

export default function ProtectedAdminRoute({ children }) {
  const [session, setSession] = useState(undefined); // undefined = loading

  useEffect(() => {
    // getUser() validates the JWT with the Supabase server (not just localStorage)
    supabase.auth.getUser().then(({ data: { user } }) => {
      setSession(user ?? null);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, s) => {
      setSession(s?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (session === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader size={24} className="animate-spin text-gray-400" />
      </div>
    );
  }

  const ADMIN_EMAIL = 'orenbsb@gmail.com';
  if (!session) return <Navigate to="/admin/login" replace />;
  if (session.email !== ADMIN_EMAIL) return <Navigate to="/" replace />;
  return children;
}
